import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";

import MediaTypes from "../types/mediaTypes";
import schema from "./schema";
import AgentCell from "@/react/features/vcc/agent-assignments/cells/AgentCell";
import QueueCell from "@/react/features/vcc/agent-assignments/cells/QueueCell";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.agentId, "Agent ID"),
        type: TYPES.ID,
        importable: true,
      },
      {
        ...getColumnDef(schema.fields.agentName, "Agent Username"),
        type: TYPES.STRING,
        editable: true,
        editableCell: AgentCell,
        minSize: 300,
      },
      {
        ...getColumnDef(schema.fields.queueId, "Queue ID"),
        type: TYPES.ID,
        importable: true,
      },
      {
        ...getColumnDef(schema.fields.queueName, "Queue Name"),
        type: TYPES.STRING,
        editable: true,
        editableCell: QueueCell,
        minSize: 300,
      },
      {
        ...getColumnDef(schema.fields.mediaType, "Media Type"),
        type: TYPES.STRING,
        options: Object.fromEntries(
          Object.values(MediaTypes).map((mt) => [mt, mt])
        ),
        importable: true,
      },
      {
        ...getColumnDef(schema.fields.isEnabled, "Enabled"),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.skillLevel, "Skill Level"),
        type: TYPES.NUMBER,
        editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
